<template>
  <div class="container-fluid customer-media-container">
    <!-- home img
    <b-row>
      <b-col lg="2" md="5" cols="5" class="mx-auto">
       
      </b-col>
    </b-row> -->
    <!-- title -->
    <b-row class="">
      <b-col xl="6" lg="8" class="mx-auto mt-md-4 mt-3">
        <h2 class="welcomeUserHomeH2DY mb-0">Close Your Eyes and Listens</h2>
      </b-col>
    </b-row>
    <AudioPlaylistPlayer
      v-if="tracks.length > 0"
      client_name="DY"
      :playlist_title="playlist_title"
      :tracks="tracks"
    />
  </div>
</template>

<script>
import AudioPlaylistPlayer from "@/components/media_components/AudioPlaylistPlayer.vue";
import MediaSimpleCardList from "@/components/media_components/MediaSimpleCardList.vue";
import SimpleMediaCard from "@/components/media_components/SimpleMediaCard.vue";
import CoolLightBox from "vue-cool-lightbox";
import axios from "axios";

export default {
  name: "DoOmYogaCustomerMeditationAudioPlaylist",
  components: {
    MediaSimpleCardList,
    CoolLightBox,
    SimpleMediaCard,
    AudioPlaylistPlayer,
  },
  data() {
    return {
      login_user: window.localStorage.getItem("user"),
      user_name: "",
      playlist_title: "",
      playlist_id: null,

      tracks: [
        // {
        //   id: 1,
        //   title: "Hey!",
        //   artist: "Benjamin Tissot",
        //   album: "",
        //   url: "https://www.bensound.com/bensound-music/bensound-hey.mp3",
        //   cover_art_url: "https://www.bensound.com/bensound-img/hey.jpg",
        // },
        // {
        //   id: 2,
        //   artist: "Benjamin Tissot",
        //   title: "Ukulele",
        //   album: "",
        //   url: "https://www.bensound.com/bensound-music/bensound-ukulele.mp3",
        //   cover_art_url: "https://www.bensound.com/bensound-img/ukulele.jpg",
        // },
        // {
        //   id: 3,
        //   title: "Creative Minds",
        //   artist: "Benjamin Tissot",
        //   album: "",
        //   url: "https://www.bensound.com/bensound-music/bensound-creativeminds.mp3",
        //   cover_art_url:
        //     "https://www.bensound.com/bensound-img/creativeminds.jpg",
        // },
        // {
        //   id: 4,
        //   artist: "Benjamin Tissot",
        //   title: "Jazzy Frenchy",
        //   album: "",
        //   url: "https://www.bensound.com/bensound-music/bensound-jazzyfrenchy.mp3",
        //   cover_art_url:
        //     "https://www.bensound.com/bensound-img/jazzyfrenchy.jpg",
        // },
        // {
        //   id: 5,
        //   artist: "Benjamin Tissot",
        //   title: "Happy Rock",
        //   album: "",
        //   url: "https://www.bensound.com/bensound-music/bensound-happyrock.mp3",
        //   cover_art_url: "https://www.bensound.com/bensound-img/happyrock.jpg",
        // },
        // {
        //   id: 6,
        //   artist: "Benjamin Tissot",
        //   title: "Memories",
        //   album: "",
        //   url: "https://www.bensound.com/bensound-music/bensound-memories.mp3",
        //   cover_art_url: "https://www.bensound.com/bensound-img/memories.jpg",
        // },
        // {
        //   id: 7,
        //   artist: "Benjamin Tissot",
        //   title: "Acoustic Breeze",
        //   album: "",
        //   url: "https://www.bensound.com/bensound-music/bensound-acousticbreeze.mp3",
        //   cover_art_url:
        //     "https://www.bensound.com/bensound-img/acousticbreeze.jpg",
        // },
      ],
    };
  },
  mounted() {
    this.playlist_id = this.$route.params.id;
    console.log(this.playlist_id);
    // this.selected_category = [Number(this.$route.params.id)];
    this.getAudiosRequest();
  },
  methods: {
    getAudiosRequest() {
      axios
        .get("/media/library/category/" + this.playlist_id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DY",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data.library_media);
          console.log(response.data.library_media.length);
          this.playlist_title = response.data.title;
          this.tracks = response.data.library_media;

          // this.tracks = this.tracks.concat(this.tracks);
          // this.tracks = this.tracks.concat(this.tracks);
        });
    },
  },
};
</script>
<style scoped::v-deep >
@import "../../css/doom-yoga-audio-player-styles.css";
</style>


// WEBPACK FOOTER //
// src/components/doom_yoga/customer/Meditation/AudiosList.vue